"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PromoAppliesTo = void 0;
var PromoAppliesTo;
(function (PromoAppliesTo) {
    PromoAppliesTo["AssocBundles"] = "assoc_bundles";
    PromoAppliesTo["AssocMostExpensive"] = "assoc_most_expensive";
    PromoAppliesTo["Order"] = "order";
})(PromoAppliesTo = exports.PromoAppliesTo || (exports.PromoAppliesTo = {}));
